import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PrintFormatsService } from "../print-formats.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-edit-fields-of-formats",
  templateUrl: "./edit-fields-of-formats.component.html",
  styleUrls: ["./edit-fields-of-formats.component.sass"],
})
export class EditFieldsOfFormatsComponent implements OnInit {
  operation: string;
  fieldPrintFormat;
  idFormat: string;
  routing = RoutingConstants.fieldsPrintsFormatsRoutingEdit;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private printFormatsService: PrintFormatsService,
    private toastrAlertService: ToastrAlertService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
    this.operation = this.activatedRoute.data["_value"]["operation"];
    this.getFieldOfFormat();
  }

  initFormGroup() {
    this.fieldPrintFormat = new FormGroup({
      cfDescCampo: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      cfIdCampo: new FormControl("", [
        Validators.required,
        Validators.maxLength(16),
      ]),
      cfIdFormato: new FormControl("", [
        Validators.required,
        Validators.maxLength(64),
      ]),
      cfLongMax: new FormControl("", [Validators.required]),
      cfObligatorio: new FormControl("", [
        Validators.required,
        Validators.maxLength(2),
      ]),
      cfTagXml: new FormControl("", [
        Validators.required,
        Validators.maxLength(32),
      ]),
    });
  }

  setValues(data) {
    this.fieldPrintFormat.patchValue({
      cfDescCampo: data.cfDescCampo,
      cfIdCampo: data.id.cfIdCampo,
      cfIdFormato: data.id.cfIdFormato,
      cfLongMax: data.cfLongMax,
      cfObligatorio: data.cfObligatorio,
      cfTagXml: data.cfTagXml,
    });
  }

  getFieldOfFormat() {
    if (
      this.operation === "edicion" &&
      this.activatedRoute.snapshot.params.id
    ) {
      let id = JSON.parse(this.activatedRoute.snapshot.params.id);
      if (id["cfIdFormato"] && id["cfIdCampo"]) {
        this.idFormat = id["cfIdFormato"];
        this.printFormatsService
          .getFieldOfPrintFormatById(id["cfIdFormato"], id["cfIdCampo"])
          .subscribe(
            (data) => {
              this.setValues(data);
            },
            (err) => {
              this.toastrAlertService.toastrFail(err.error.mensaje);
            }
          );
      }
    }
  }

  goList() {
    this.router.navigate([this.routing.list, this.idFormat]);
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.fieldPrintFormat.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      this.printFormatsService
        .updateFieldOfPrintFormat(this.fieldPrintFormat.value)
        .subscribe(
          (data) => {
            this.toastrAlertService.toastrSuccess(
              data["mensaje"],
              this.routing.list,
              this.idFormat
            );
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          }
        );
    }
  }
}
